(function () {
  'use strict';

  function formatMoney(cents) {
    // Use Shopify's money format if available, fallback to Turkish format
    var fmt = (window.Shopify && window.Shopify.money_format) || '{{amount}} TL';
    // Kuruş gösterilmez (Patron, 8 Ağu): tam liraya yuvarlanır.
    var amount = Math.round(cents / 100).toString();
    // Replace {{amount_no_decimals}}, {{amount}}, {{amount_with_comma_separator}} etc.
    return fmt
      .replace('{{amount_no_decimals_with_comma_separator}}', amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'))
      .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
      .replace('{{amount_with_comma_separator}}', amount)
      .replace('{{amount}}', amount);
  }

  function getMainSummary() {
    return document.getElementById('delvia-qty-price-main');
  }

  function getStickySummary() {
    return document.getElementById('delvia-qty-price-sticky');
  }

  // Main quantity input (inside buy-buttons, not sticky bar)
  function getMainQtyInput() {
    var main = getMainSummary();
    if (!main) return null;
    // Walk up to the product-form and find the quantity input
    var form = main.closest('.product-form') || document.querySelector('[data-type="add-to-cart-form"]');
    if (form) return form.querySelector('.quantity__input');
    return document.querySelector('.main-product-form .quantity__input');
  }

  // Sticky bar quantity input
  function getStickyQtyInput() {
    var bar = document.querySelector('sticky-atc-bar');
    if (!bar) return null;
    return bar.querySelector('.quantity__input');
  }

  function updateSummary(summaryEl, price, compare, qty) {
    if (!summaryEl) return;
    // Stokta olmayan üründe fiyat GÖSTERİLMEZ (Patron, 4 Ağu).
    // Bu kontrol Liquid tarafındaki kapının TAMAMLAYICISIDIR, tekrarı değil:
    // burası tüm [id^="delvia-total-price"] alanlarına yazdığı için, Liquid
    // tutarı boş bassa bile adet senkronu ilk çalıştığında fiyatı geri
    // yazardı — yani yalnız şablonu düzeltmek yetmiyordu.
    if (summaryEl.dataset.stokYok === '1') return;

    var total = price * qty;
    var formatted = formatMoney(total);

    // Update all total price spans (sale + regular)
    summaryEl.querySelectorAll('[id^="delvia-total-price"]').forEach(function (el) {
      el.textContent = formatted;
    });

    if (compare > price) {
      var compareTotal = compare * qty;
      var pct = Math.round((compare - price) * 100 / compare);
      var compareEl  = summaryEl.querySelector('[id^="delvia-compare-price"]');
      var discountEl = summaryEl.querySelector('[id^="delvia-discount-badge"]');
      if (compareEl)  compareEl.textContent  = formatMoney(compareTotal);
      if (discountEl) discountEl.textContent = '%' + pct + ' İndirim';
    }
  }

  function getPrices(summaryEl) {
    if (!summaryEl) return { price: 0, compare: 0 };
    return {
      price:   parseInt(summaryEl.dataset.price   || 0, 10),
      compare: parseInt(summaryEl.dataset.compare || 0, 10)
    };
  }

  var _syncing = false;

  function onMainQtyChange() {
    if (_syncing) return;
    var mainInput = getMainQtyInput();
    if (!mainInput) return;
    var qty = parseInt(mainInput.value || 1, 10);

    var prices = getPrices(getMainSummary());
    updateSummary(getMainSummary(), prices.price, prices.compare, qty);
    updateSummary(getStickySummary(), prices.price, prices.compare, qty);

    // Sync sticky
    var stickyInput = getStickyQtyInput();
    if (stickyInput && parseInt(stickyInput.value, 10) !== qty) {
      _syncing = true;
      stickyInput.value = qty;
      _syncing = false;
    }
  }

  function onStickyQtyChange() {
    if (_syncing) return;
    var stickyInput = getStickyQtyInput();
    if (!stickyInput) return;
    var qty = parseInt(stickyInput.value || 1, 10);

    var prices = getPrices(getMainSummary());
    updateSummary(getMainSummary(), prices.price, prices.compare, qty);
    updateSummary(getStickySummary(), prices.price, prices.compare, qty);

    // Sync main
    var mainInput = getMainQtyInput();
    if (mainInput && parseInt(mainInput.value, 10) !== qty) {
      _syncing = true;
      mainInput.value = qty;
      // Trigger native change so theme JS stays in sync
      mainInput.dispatchEvent(new Event('change', { bubbles: true }));
      _syncing = false;
    }
  }

  function attachListeners() {
    var mainInput = getMainQtyInput();
    if (mainInput) {
      mainInput.addEventListener('change', onMainQtyChange);
      mainInput.addEventListener('input',  onMainQtyChange);
    }

    var stickyInput = getStickyQtyInput();
    if (stickyInput) {
      stickyInput.addEventListener('change', onStickyQtyChange);
      stickyInput.addEventListener('input',  onStickyQtyChange);
    }
  }

  function init() {
    // Run initial update for qty=1
    var mainInput = getMainQtyInput();
    var qty = mainInput ? parseInt(mainInput.value || 1, 10) : 1;
    var prices = getPrices(getMainSummary());
    updateSummary(getMainSummary(), prices.price, prices.compare, qty);
    updateSummary(getStickySummary(), prices.price, prices.compare, qty);

    attachListeners();

    // Re-attach after sticky bar becomes visible (lazy-loaded or scroll-triggered)
    var observer = new MutationObserver(function () {
      var stickyInput = getStickyQtyInput();
      if (stickyInput && !stickyInput._delviaAttached) {
        stickyInput._delviaAttached = true;
        stickyInput.addEventListener('change', onStickyQtyChange);
        stickyInput.addEventListener('input',  onStickyQtyChange);
        // Sync initial value from main
        if (mainInput) stickyInput.value = mainInput.value;
        var p = getPrices(getStickySummary());
        if (p.price) updateSummary(getStickySummary(), p.price, p.compare, parseInt(mainInput?.value || 1, 10));
      }
    });
    var stickyBar = document.querySelector('sticky-atc-bar');
    if (stickyBar) observer.observe(stickyBar, { childList: true, subtree: true, attributes: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
